module.exports = __webpack_public_path__ + "img/etc.6c54e5a6.svg";